module.exports = __webpack_public_path__ + "static/media/21.20230bb3.png";